import { FieldProps } from "@/core/components/Field";
import { useClaimCheck } from "@/core/hooks/useClaimCheck/useClaimCheck";
import { RedirectSource } from "@/core/types/types";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { useGetPreviousAnswers } from "@/core/hooks/useGetPreviousAnswers/useGetPreviousAnswers";
import { useEffect } from "react";

const Redirect = ({ field }: FieldProps) => {
  const { flush } = useClaimCheck();
  const { properties } = field;
  const redirectionLinkVariable: string | undefined =
    properties?.[RedirectSource.RedirectionLinkVariable];
  const redirectionLink: string | undefined =
    properties?.[RedirectSource.RedirectionLink];

  // Firstly we check the redirection-link
  if (!redirectionLink && !redirectionLinkVariable) {
    throw new Error("No redirection source provided");
  }

  const translatedLink: string = t(redirectionLink);

  // Check if alias is found in the translations object and if link is valid
  if (translatedLink && translatedLink.indexOf("https") === -1) {
    throw new Error(
      "Translated url is invalid or absent in translations object"
    );
  }

  /**
   * TODO: Should we think of the new naming for this hook since
   * this option is intended to fetch the "static" variables
   * from camunda model process instance (like `deeplink`) and it
   * differentiates a bit from previously entered answers?
   */

  const { result } = useGetPreviousAnswers(redirectionLinkVariable ?? "");
  const camundaVariableData: { [key: string]: string | Location } = result;
  const camundaVariableValue: string | Location =
    camundaVariableData[redirectionLinkVariable!];
  const redirectLink: string | Location =
    translatedLink || camundaVariableValue;

  useEffect(() => {
    if (redirectLink) {
      flush().then(() => (window.location = redirectLink as Location));
    }
  }, [redirectLink]);

  return null;
};

export default Redirect;
